<template>
	<div class="footer">
		<div class="wrap">
			<div class="logo_flex">
				<img src="@/assets/img/logo_bai.png" class="logo pc" alt="">
				<div class="nav">
					<div class="li" @click="router_url('/index')">{{$t('首页')}}<img src="@/assets/img/jiantou_wap.png" class="ioc wap" alt=""></div>
					<div class="li" @click="router_url('/product')">{{$t('产品')}}<img src="@/assets/img/jiantou_wap.png" class="ioc wap" alt=""></div>
					<div class="li" @click="router_url('/patent')">{{$t('专利')}}<img src="@/assets/img/jiantou_wap.png" class="ioc wap" alt=""></div>
					<!-- <div class="li" @click="router_url('/news')">{{$t('新闻')}}<img src="@/assets/img/jiantou_wap.png" class="ioc wap" alt=""></div> -->
					<div class="li" @click="router_url('/partner')">{{$t('合作伙伴')}}<img src="@/assets/img/jiantou_wap.png" class="ioc wap" alt=""></div>
					<div class="li" @click="router_url('/contact')">{{$t('联系我们')}}<img src="@/assets/img/jiantou_wap.png" class="ioc wap" alt=""></div>
				</div>
			</div>
			<div class="address">
				<div class="li">{{$t('办公地点')}}：{{info.list[$i18n.locale]&&info.list[$i18n.locale].address}}</div>
				<div class="li">{{$t('邮箱')}}：{{info.email}}</div>
				<img src="@/assets/img/logo_bai.png" @click="router_url('/index')" class="logo wap" alt="">
			</div>
		</div>
		<div class="copyright">
			Copyright @ 2025 广州万周成方科技有限公司 All Rights Reserved
			<a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2025455304号-1</a>
			<img src="@/assets/img/miit.png" alt="">
			<a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44011502001383" target="_blank">粤公网安备44011502001383号</a>
		</div>
	</div>
</template>
<script>
export default {
	name: 'footer_html',
	data() {
		return {
			info:{
				list:{}
			}
		}
	},
	mounted() {
		this.init();
	},
	methods: {
		init(){
			this.$get("front/about",{}).then((res) => {
				this.info = res.data;
			}).catch((err)=>{
				this.$message.error(err);
			});
		}
	}
}
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/footer_html.vue